//参数下拉
import chooseCampusList from './commonplugin/chose_param/chooseCampusList.vue'
Vue.component('chooseCampusList', chooseCampusList)
import chooseCurseScheme from './commonplugin/chose_param/chooseCurseScheme.vue'
Vue.component('chooseCurseScheme', chooseCurseScheme)
import chooseGradation from './commonplugin/chose_param/chooseGradation.vue'
Vue.component('chooseGradation', chooseGradation)
import chooseGrade from './commonplugin/chose_param/chooseGrade.vue'
Vue.component('chooseGrade', chooseGrade)
import chooseTeachWeek from './commonplugin/chose_param/chooseTeachWeek.vue'
Vue.component('chooseTeachWeek', chooseTeachWeek)
import chooseTerm from './commonplugin/chose_param/chooseTerm.vue'
Vue.component('chooseTerm', chooseTerm)

import comm_breadcrumb_bar from './commonplugin/common/comm_breadcrumb_bar.vue'
Vue.component('comm_breadcrumb_bar', comm_breadcrumb_bar)
import comm_action_bar from './commonplugin/common/comm_action_bar.vue'
Vue.component('comm_action_bar', comm_action_bar)
import comm_main from './commonplugin/common/comm_main.vue'
Vue.component('comm_main', comm_main)
import comm_filtering from './commonplugin/common/comm_filtering.vue'
Vue.component('comm_filtering', comm_filtering)
import comm_homework from './commonplugin/common/comm_homework.vue'
Vue.component('comm_homework', comm_homework)
import commSearch from './commonplugin/common/commSearch.vue'
Vue.component('commSearch', commSearch)
import comm_mulit_media from './commonplugin/common/comm_mulit_media.vue'
Vue.component('comm_mulit_media', comm_mulit_media)

//zTree
import ztree from './commonplugin/ztree'
Vue.component('comm_ztree', ztree)
//下载 and 收藏按钮
import collection_and_down from './commonplugin/collection_and_down'
Vue.component('collection_and_down', collection_and_down)
import inputTree from './commonplugin/input_tree.vue'
Vue.component('inputTree', inputTree)
//table and 分页
import ajaxPagerTable from './commonplugin/ajaxPagerTable.vue'
Vue.component('ajaxPagerTable', ajaxPagerTable)
//简洁版编辑器
import simpleUEditor from './commonplugin/simple_uediter.vue'
Vue.component('simple_ueditor', simpleUEditor)
//编辑器
import UEditor from './commonplugin/uediter.vue'
Vue.component('UEditor', UEditor)

//流程审批图
import commitProcess from './commonplugin/commitProcess.vue'
Vue.component('commitProcess', commitProcess)

import './commonplugin/choose/index.js'
import './commonplugin/common/hbox-vbox.js'
import './commonplugin/fileUpload/index.js'



// import comm_resource_prepare from './commonplugin/common/comm_resource_prepare.vue'
// Vue.component('comm_resource_prepare', comm_resource_prepare)
// import comm_resList from './commonplugin/common/comm_resList.vue'
// Vue.component('comm_resList', comm_resList)
// import comm_sources from './commonplugin/common/comm_sources.vue'
// Vue.component('comm_sources', comm_sources)
// import comm_package from './commonplugin/common/comm_package.vue'
// Vue.component('comm_package', comm_package)
// Vue.component('eduCampusSelect', require('components/choose_course/eduCampusSelect'))//查询校区111
// import eduCampusSelect from './commonplugin/choose_course/campusSelect.vue'
// Vue.component('eduCampusSelect', eduCampusSelect)
// import year_term_select from './commonplugin/choose_course/year_term_select.vue'
// Vue.component('year_term_select', year_term_select)
// import course_class_map from './commonplugin/choose_course/course_class_map.vue'
// Vue.component('course_class_map', course_class_map)
// import comm_mulit_media from './commonplugin/common/comm_mulit_media.vue'
// Vue.component('comm_mulit_media', comm_mulit_media)
// import comm_pic from './commonplugin/common/comm_pic'
// Vue.component('comm_pic', comm_pic)
// import comm_filtering from './commonplugin/common/comm_filtering'
// Vue.component('comm_filtering', comm_filtering)
// import comm_seaPre from './commonplugin/common/comm_seaPre.vue'
// Vue.component('comm_seaPre', comm_seaPre)
// import comm_details from './commonplugin/common/comm_details.vue'
// Vue.component('comm_details', comm_details)
// import comm_select_tree from './commonplugin/common/comm_select_tree.vue'
// Vue.component('comm_select_tree', comm_select_tree)
// import comm_search from './commonplugin/common/comm_search.vue'
// Vue.component('comm_search', comm_search)
// import comm_main_two from './commonplugin/common/comm_main_two.vue'
// Vue.component('comm_main_two', comm_main_two)
// import comm_paper_search from './commonplugin/common/comm_paper_search.vue'
// Vue.component('comm_paper_search', comm_paper_search)
// import comm_paper from './commonplugin/common/comm_paper.vue'
// Vue.component('comm_paper', comm_paper)





// import timeline from './commonplugin/common/timeline'
// Vue.component('comm_timeline', timeline)




// import auto_focus_tab_wrap from './commonplugin/common/auto_focus_tab_wrap'
// Vue.component('comm_auto_focus_tab_wrap', auto_focus_tab_wrap)
// import auto_focus_tab_item from './commonplugin/common/auto_focus_tab_item'
// Vue.component('comm_auto_focus_tab_item', auto_focus_tab_item)

// import edu_editable_info_list from './commonplugin/edu/edu_editable_info_list'
// Vue.component('edu_editable_info_list', edu_editable_info_list)
// import edu_view_info_list from './commonplugin/edu/edu_view_info_list'
// Vue.component('edu_view_info_list', edu_view_info_list)



// 约听评课
// import edu_course_listening_grade_list from './commonplugin/course-listening/edu_course_listening_grade_list.vue'
// Vue.component('edu_course_listening_grade_list', edu_course_listening_grade_list)

// import edu_course_listening_course_list from './commonplugin/course-listening/edu_course_listening_course_list.vue'
// Vue.component('edu_course_listening_course_list', edu_course_listening_course_list)

// import edu_course_listening_add_update2 from './commonplugin/course-listening/edu_course_listening_add_update2'
// Vue.component('edu_course_listening_add_update2', edu_course_listening_add_update2)

// import edu_course_listening_theme_list1 from './commonplugin/course-listening/edu_course_listening_theme_list1'
// Vue.component('edu_course_listening_theme_list1', edu_course_listening_theme_list1)
// import edu_course_listening_template_list1 from './commonplugin/course-listening/edu_course_listening_template_list1'
// Vue.component('edu_course_listening_template_list1', edu_course_listening_template_list1)

// Vue.component('eduSateSelect', require('./commonplugin/edu/eduSateSelect'))
// Vue.component('eduLinkRoleListSelect', require('./commonplugin/edu/eduLinkRoleListSelect'))
// Vue.component('eduRoleLevelSelect', require('./commonplugin/edu/eduRoleLevelSelect'))
// Vue.component('eduOrgGradeSelect', require('./commonplugin/edu/eduOrgGradeSelect'))
// Vue.component('eduYesNoSelect', require('./commonplugin/edu/eduYesNoSelect'))
// Vue.component('eduOrgPopSelect', require('./commonplugin/edu/eduOrgPopSelect'))
// Vue.component('eduCodeAjaxSelect', require('./commonplugin/edu/eduCodeAjaxSelect'))
// Vue.component('eduCodeSelect', require('./commonplugin/edu/eduCodeSelect'))

// Vue.component('eduCampusSelect', require('./commonplugin/edu/eduCampusSelect'))//查询校区
// Vue.component('eduGradeSelect', require('./commonplugin/edu/eduGradeSelect'))//查询年级
// Vue.component('eduSchoolSelect', require('./commonplugin/edu/eduSchoolSelect'))//查询学校
// Vue.component('eduSchoolAllSelect', require('./commonplugin/edu/eduSchoolAllSelect'))//查询学校
// Vue.component('eduCourseSelect', require('./commonplugin/edu/eduCourseSelect'))//查询课程基础信息
// Vue.component('eduGradationSelect', require('./commonplugin/edu/eduGradationSelect'))//查询学段
// Vue.component('eduLeamYearSelect', require('./commonplugin/edu/eduLeamYearSelect'))//查询学年
// Vue.component('eduSemesterSelect', require('./commonplugin/edu/eduSemesterSelect'))//查询学期
// Vue.component('eduClassSelect', require('./commonplugin/edu/eduClassSelect'))//查询班级


// Vue.component('localPagerTable', require('./commonplugin/localPagerTable'))
// Vue.component('ajaxPagerTable', require('./commonplugin/ajaxPagerTable'))



// Vue.component('zujuan', require('./commonplugin/zuJuanD.vue'))
// Vue.component('viewZuJuan', require('./commonplugin/viewZuJuanZ'))
// Vue.component('ueditor', require('./commonplugin/ueditor'))
// Vue.component('question-bank', require('./commonplugin/task_paper/listQuestionTraining'))
// Vue.component('paper-add', require('./commonplugin/task_paper/paperAddTraining'))
// Vue.component('paper-edit', require('./commonplugin/task_paper/paperEditTraining'))
// Vue.component('paper-view', require('./commonplugin/task_paper/paperSimpleViewModule'))
/*Vue.component('simple-u-editor', require('./commonplugin/simple_uediter.vue'))*/
// Vue.component('paper-simple-choose', require('./commonplugin/task_paper/simpleChoosePaperC'))
// import circle_progress_bar from './commonplugin/circle_progress_bar'
// Vue.component('circle_progress_bar', circle_progress_bar)




// //档案模块

// import './commonplugin/edu/edu_archives_ajax_select_factory.js'
// import './commonplugin/edu/edu_archives_ajax_remote_select_factory.js'
// Vue.component('edu_archives_LiXiaoBiaoZhiSelect', require('./commonplugin/edu/edu_archives_LiXiaoBiaoZhiSelect'))//离校标识
// Vue.component('edu_archives_WageTypeSelect', require('./commonplugin/edu/edu_archives_WageTypeSelect'))//教师工资-工资类型

// Vue.component('edu_archives_stu_Graduation', require('./commonplugin/edu/edu_archives_stu_Graduation'))//学生-毕业结业档案
// Vue.component('edu_archives_stu_Basic', require('./commonplugin/edu/edu_archives_stu_Basic'))//学生-基础档案
// Vue.component('edu_archives_stu_Roll', require('./commonplugin/edu/edu_archives_stu_Roll'))//学生-学籍档案
// Vue.component('edu_archives_tea_Growth', require('./commonplugin/edu/edu_archives_tea_Growth'))//教师-成长档案
// Vue.component('edu_archives_tea_Personnel', require('./commonplugin/edu/edu_archives_tea_Personnel'))//教师-人事档案



// import './commonplugin/eduOrgPopMultiSelect/index.js'
// import './commonplugin/fullLoading/index.js'


// //协同备课
// Vue.component('edu_prepare_JXSelect', require('components/edu/edu_prepare_JXSelect'))
// Vue.component('edu_prepare_FileTypeSelect', require('components/edu/edu_prepare_FileTypeSelect'))
// Vue.component('CssCircle', require('components/common/css-circle.vue')) // copy from https://github.com/qddegtya/v-circle
// Vue.component('edu_prepare_grede', require('components/prepare/edu_prepare_grade.vue'))
// Vue.component('edu_prepare_subject', require('components/prepare/edu_prepare_subject.vue'))
// Vue.component('edu_prepare_year', require('components/prepare/edu_prepare_year.vue'))
// Vue.component('edu_prepare_semester', require('components/prepare/edu_prepare_semester.vue'))
// Vue.component('edu_prepare_section', require('components/prepare/edu_prepare_section.vue'))
// Vue.component('edu_prepare_template', require('./commonplugin/prepare/edu_prepare_template.vue'))
// Vue.component('edu_prepare_workTemplate', require('./commonplugin/prepare/edu_prepare_workTemplate.vue'))

// //课程
// //码表调用system 获取数据集方法
// Vue.component('edu_course_code_list', require('./commonplugin/course/edu_course_code_list.vue'))
// Vue.component('edu_course_campuse_list', require('./commonplugin/course/edu_course_campuse_list.vue'))
// Vue.component('edu_course_section_list', require('./commonplugin/course/edu_course_section_list.vue'))
// Vue.component('edu_course_grade_list', require('./commonplugin/course/chooseGrade.vue'))
// Vue.component('edu_course_info_list', require('./commonplugin/course/edu_course_info_list.vue'))
// Vue.component('edu_course_school_list', require('./commonplugin/course/edu_course_school_list.vue'))
// Vue.component('edu_course_teacher_map', require('./commonplugin/course/edu_course_teacher_map.vue'))
// Vue.component('edu_course_class_map', require('./commonplugin/course/edu_course_class_map.vue'))
// Vue.component('edu_course_class_list', require('./commonplugin/course/edu_course_class_list.vue'))
// Vue.component('edu_course_term_list', require('./commonplugin/course/edu_course_term_list.vue'))
// //成绩分析
// Vue.component('eduSubjectTypeSelect', require('./commonplugin/edu/eduSubjectTypeSelect'))
// //deck
// //deck
// import eduDeckSchoolSelect from './commonplugin/edu/eduDeckSchoolSelect'
// Vue.component('eduDeckSchoolSelect', eduDeckSchoolSelect);


//培训学习
// import training_upload from './commonplugin/PickResource/upload.vue'
// Vue.component('training_upload',training_upload)
// import commChapterTree from './commonplugin/common/comm_chapter_tree'
// Vue.component('commChapterTree', commChapterTree)
// import personShow from './commonplugin/common/person_show'
// Vue.component('person-show', personShow)
// import common_res_search from './commonplugin/common/common_res_search.vue'
// Vue.component('common_res_search', common_res_search)
// import comm_question from './commonplugin/common/comm_question.vue'
// Vue.component('comm_question', comm_question)



// WEBPACK FOOTER //
// ./src/registercommonplugin.js